var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h2',{staticClass:"header-title-int"},[_vm._v(" Pago en linea ")]),_c('p',{staticClass:"grey--text"},[_vm._v(" Busca tu recibo ingresando la información solicitada. Luego podrás realizar el pago en línea sin complicaciones. ")]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }